import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "components/shared/toast/toast";
import { ACCOUNT_DETAILS, ENTITY } from "services/apiEndpoints";
import { privatePut } from "services/privateRequest";
import { getDefaultDates } from "utils/utils";

const initialState = {
    accounts: [],
    accountsOnly: [],
    totalAccounts: 0,
    totalAccountsOnly: 0,
    selectedAccount: null,
    accountsModalOpen: false,
    isFetching: false,
    allAccounts: [],
    filterValues: getDefaultDates()
}

// Accounts
export const getAccountsData = createAsyncThunk("accounts/getAccountsData", async(params) => {
    // api call here
    const res = { data: { pagination: 27, data: await new Promise(res => {
        setTimeout(() => {res(Array(27).fill(null).map((_,id) => ({
            id,
            accountHolderName: "Pranil Meherkar",
            accountNumber: "7005492926489",
            totalAmount: 25000
        })).slice((params.page-1) * params.limit, params.page * params.limit))}, 2500)
    })}}

    return {
        data: res?.data?.data || [],
        totalAccounts: res?.data?.pagination || 0
    }
})

export const getAccountsOnly = createAsyncThunk("accounts/getAccountsOnly", async(params) => {
    // api call here
    const res = { data: { count: 12, data: await new Promise(res => {
        setTimeout(() => {res(Array(12).fill(null).map((_,id) => ({
            id,
            accountHolderName: "Pranil Meherkar",
            accountNumber: "7005492926489",
            totalAmount: "25000"
        })))}, 500)
    })}}
})

export const deleteAccounts = createAsyncThunk("accounts/deleteAccounts", async(id, { dispatch }) => {
    const res = await privatePut(ACCOUNT_DETAILS + "/delete", id)
    res && toast.success("Accounts deleted successfully")
})

const accountsSlice = createSlice({
    name: "accounts",
    initialState,
    reducers: {
        setIsFetching: (state, action) => {
            state.isFetching = action.payload
        },
        setSelectedAccount: (state, action) => {
            state.selectedAccount = action.payload
            state.accountsModalOpen = !!action.payload
        },
        setAccountsModalOpen: (state, action) => {
            state.accountsModalOpen = action.payload
        },
        setFilterValues: (state, action) => {
            state.filterValues = action.payload
        }
    },
    extraReducers: {
        [getAccountsData.pending]: (state) => {
            state.isFetching = true
        },
        [getAccountsData.fulfilled]: (state, action) => {
            state.accounts = action.payload.data
            state.totalAccounts = action.payload.totalAccounts
            state.isFetching = false
        },
        [getAccountsData.rejected]: (state) => {
            state.isFetching = false
        },
        [getAccountsOnly.pending]: (state) => {
            state.isFetching = true
        },
        [getAccountsOnly.fulfilled]: (state, action) => {
            state.accountsOnly = action.payload.accountsOnly
            state.totalAccountsOnly = action.payload.totalAccountsOnly
            state.isFetching = false
        },
        [getAccountsOnly.rejected]: (state) => {
            state.isFetching = false
        },
    }
})

export default accountsSlice.reducer
export const { setIsFetching, setSelectedAccount, setAccountsModalOpen, setFilterValues } = accountsSlice.actions